import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { LarkwellMark } from '../components/LarkwellMark';
import { HelpContent } from '../components/HelpContent';
import { useSeo } from '../lib/useSeo';

export default function PublicHelp() {
  const navigate = useNavigate();
  useSeo({
    title: 'How to use Larkwell — Help & FAQ',
    description: 'A gentle guide to Larkwell: brain dump, plan your day in one tap, focus timers, AI agents, memory, and calendar sync — built for ADHD brains.',
    canonical: 'https://larkwellapp.com/help',
  });
  return (
    <div className="min-h-dvh bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      <header className="border-b border-[hsl(var(--border))] sticky top-0 bg-[hsl(var(--background))]/90 backdrop-blur z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2" data-testid="help-home-link">
            <div className="h-8 w-8 rounded-xl grid place-items-center text-white" style={{ background: 'hsl(var(--primary))' }}><LarkwellMark className="h-5 w-5" stroke="#ffffff" /></div>
            <span className="font-display text-xl font-700 tracking-tight">Larkwell</span>
          </button>
          <Button onClick={() => navigate('/login')} className="rounded-xl" style={{ background: 'hsl(var(--primary))' }} data-testid="help-signin-button">Start free</Button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="font-display text-3xl font-700">How to use Larkwell</h1>
        <p className="text-[hsl(var(--muted-foreground))] mt-2 mb-7 max-w-xl">A gentle guide to getting the most out of Larkwell — the AI planner built for ADHD brains. Read before you sign up, or keep it handy as you go.</p>
        <HelpContent includeTesters={true} />
        <div className="mt-8 text-center">
          <Button size="lg" onClick={() => navigate('/login')} className="rounded-xl h-12 px-6" style={{ background: 'hsl(var(--primary))' }} data-testid="help-cta-button">Try Larkwell free</Button>
        </div>
      </main>
      <footer className="border-t border-[hsl(var(--border))] py-8 text-center text-sm text-[hsl(var(--muted-foreground))]">Larkwell — made with care for ADHD minds.</footer>
    </div>
  );
}
